import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../../environments/environment';
import { CredentialTransitionStatus } from '../../models/credentialTransitionStatus';

@Injectable({ providedIn: 'root' })
export class CredentialTransitionService
{
  private readonly url = `${environment.apiServer.webApiURL}/CredentialTransition`;

  constructor(private http: HttpClient)
  {
  }

  begin(processVersionID: number)
  {
    return this.http.post<CredentialTransitionStatus>(`${this.url}/Begin`, processVersionID);
  }

  getPayDecreaseWarning(userID: number)
  {
    return this.http.get<Pick<CredentialTransitionStatus, 'payDecreaseWarning' | 'attemptID' | 'processVersionID'>>(
      `${this.url}/PayDecreaseWarning/${userID}`
    );
  }

  getPayDecreaseWarningForOversight(reviewID: number)
  {
    return this.http.get<Pick<CredentialTransitionStatus, 'payDecreaseWarning' | 'attemptID' | 'processVersionID'>>(
      `${this.url}/PayDecreaseWarningForOversight/${reviewID}`
    );
  }

  confirmPayDecrease(attemptID: number, processVersionID: number)
  {
    return this.http.post<void>(`${this.url}/ConfirmPayDecrease`,
      {
        attemptID,
        processVersionID
      });
  }

  getStatus()
  {
    return this.http.get<CredentialTransitionStatus>(this.url);
  }

  beginCredentialUpload()
  {
    return this.http.post<{ uploadToken: string }>(`${this.url}/BeginCredentialUpload`, {});
  }

  saveExamDate(examDate: string)
  {
    return this.http.post<CredentialTransitionStatus>(`${this.url}/ExamDate`, { examDate });
  }

  acknowledgeSignaturePrompt()
  {
    return this.http.post<CredentialTransitionStatus>(`${this.url}/AcknowledgeSignaturePrompt`, {});
  }
}
